module.exports = __webpack_public_path__ + "img/1593820829.f2db6127.jpg";